import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCompetition } from '../contexts/CompetitionContext';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Alert, AlertDescription } from './ui/alert';
import { ArrowLeft, AlertTriangle, CheckCircle, Users, Mountain } from 'lucide-react';
import { getJudges, CreateCompetition, getCompetitionById } from '../services/apiServices';
import { Badge } from './ui/badge';

export const JudgeAssignment = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [competition, setCompetition] = useState(null);
    const [judges, setJudges] = useState([]);
    const [loading, setLoading] = useState(false);

    console.log(competition, 'competition');

    useEffect(() => {
        async function fetchCompetition() {
            try {
                let organiserId = JSON.parse(localStorage.getItem("loggedAdminInfo")) ? JSON.parse(localStorage.getItem("loggedAdminInfo")).organizerId : "";
                const response = await getCompetitionById(location.state?._id);

                if (!response || response === "false") {
                    return;
                } else {
                    const competitionData = await response.json();
                    console.log(competitionData, 'hvdfhdhb');

                    setCompetition(competitionData)
                }
            } catch (error) {
                console.error("Error fetching climbers:", error);
            }
        }
        if (location.state?._id) {
            fetchCompetition();
        }
    }, [location.state]);


    useEffect(() => {
        async function fetchJudges() {
            try {
                let organiserId = JSON.parse(localStorage.getItem("loggedAdminInfo")) ? JSON.parse(localStorage.getItem("loggedAdminInfo")).organizerId : "";
                const judgeResponse = await getJudges(organiserId);

                if (!judgeResponse || judgeResponse === "false") {
                    return;
                } else {
                    const judgeData = await judgeResponse.json();
                    console.log(judgeData, 'judgeData');

                    if (judgeData) {
                        setJudges(judgeData);
                    }
                }
            } catch (error) {
                console.error("Error fetching judge:", error);
            }
        }

        fetchJudges();
    }, []);

    // Filter judges to only show those that are in competition.judges array
    const availableJudges = (judges != null && judges.length > 0) ? judges.filter(judge =>
        competition?.judges?.includes(judge._id)
    ) : [];

    // Get assigned judge IDs to filter them out from available options
    const assignedJudgeIds = competition?.boulders
        ?.filter(boulder => boulder.judgeId)
        .map(boulder => boulder.judgeId) || [];

    const handleAssignJudge = async (boulderId, judgeId) => {
        setLoading(true);
        try {
            // Update the boulder with judgeId
            const updatedBoulders = competition.boulders.map(boulder =>
                boulder._id === boulderId
                    ? { ...boulder, judgeId: judgeId === 'none' ? null : judgeId }
                    : boulder
            );

            // Prepare complete competition update data
            const competitionUpdateData = {
                ...competition,
                boulders: updatedBoulders
            };

            console.log('Updating competition with boulder assignment:', competitionUpdateData);

            // Update local state
            setCompetition(competitionUpdateData);

        } catch (error) {
            console.error('Error assigning judge:', error);
        } finally {
            setLoading(false);
        }
    };

    // Get available judges for a specific boulder (exclude already assigned judges)
    const getAvailableJudgesForBoulder = (currentBoulder) => {
        return availableJudges.filter(judge => {
            // If this judge is not assigned to any boulder, include them
            const isAssignedToOtherBoulder = assignedJudgeIds.some(assignedJudgeId =>
                assignedJudgeId === judge._id && assignedJudgeId !== currentBoulder.judgeId
            );
            return !isAssignedToOtherBoulder;
        });
    };

    const unassignedBoulders = competition?.boulders?.filter(b => !b.judgeId) || [];
    const allBouldersAssigned = unassignedBoulders.length === 0;

    const handleSave = async () => {
        if (unassignedBoulders.length > 0) {
            const proceed = window.confirm(
                `${unassignedBoulders.length} boulder(s) still don't have judges assigned. Continue anyway?`
            );
            if (!proceed) return;
        }
        // Update competition via API
        const updateResponse = await CreateCompetition(competition._id, competition);

        if (!updateResponse.ok) {
            throw new Error(`Failed to update competition: ${updateResponse.status}`);
        }

        const updatedCompetition = await updateResponse.json();
        console.log('Updated Competition:', updatedCompetition);

        setCompetition(updatedCompetition)
        navigate('/competitiondetails', {
            state: competition,
        })
    };

    if (!competition) {
        return (
            <div className="min-h-screen bg-gray-50 p-4 md:p-6 max-w-2xl mx-auto flex items-center justify-center">
                <Card className="bg-white border-gray-200 shadow-lg w-full">
                    <CardContent className="p-6">
                        <Alert className="bg-blue-50 border-blue-200">
                            <AlertDescription className="text-blue-700 text-center">
                                Please create a competition first.
                            </AlertDescription>
                        </Alert>
                        <Button
                            onClick={() => navigate('/create-round')}
                            className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white font-medium h-11"
                        >
                            Create Competition
                        </Button>
                    </CardContent>
                </Card>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-6 max-w-4xl mx-auto">
            <div className="space-y-8">
                {/* Header */}
                <div className="flex items-center gap-4">
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => navigate('/dashboard')}
                        className="text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                    >
                        <ArrowLeft className="size-5" />
                    </Button>
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900">Judge Assignment</h1>
                        <p className="text-gray-600 mt-1">Assign judges to boulders for the competition</p>
                    </div>
                </div>

                {/* Status Alert */}
                {competition.judges?.length === 0 && (
                    <Alert className="bg-red-50 border-red-200">
                        <AlertTriangle className="size-5 text-red-600" />
                        <AlertDescription className="text-red-700 font-medium">
                            No judges have been added yet. Please add judges before assigning them to boulders.
                        </AlertDescription>
                    </Alert>
                )}

                {availableJudges.length === 0 && competition.judges?.length > 0 && (
                    <Alert className="bg-red-50 border-red-200">
                        <AlertTriangle className="size-5 text-red-600" />
                        <AlertDescription className="text-red-700 font-medium">
                            No available judges found. Please check if judges are properly added to the competition.
                        </AlertDescription>
                    </Alert>
                )}

                {!allBouldersAssigned && availableJudges.length > 0 && (
                    <Alert className="bg-orange-50 border-orange-200">
                        <AlertTriangle className="size-5 text-orange-600" />
                        <AlertDescription className="text-orange-700 font-medium">
                            {unassignedBoulders.length} boulder{unassignedBoulders.length !== 1 ? 's' : ''} without assigned judges
                        </AlertDescription>
                    </Alert>
                )}

                {allBouldersAssigned && availableJudges.length > 0 && (
                    <Alert className="bg-green-50 border-green-200">
                        <CheckCircle className="size-5 text-green-600" />
                        <AlertDescription className="text-green-700 font-medium">
                            All boulders have assigned judges
                        </AlertDescription>
                    </Alert>
                )}

                {/* Judge Information */}
                <Card className="bg-white border-gray-200 shadow-sm">
                    <CardHeader className="pb-4">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-blue-100 rounded-lg">
                                <Users className="size-6 text-blue-600" />
                            </div>
                            <div>
                                <CardTitle className="text-xl text-gray-900">Available Judges</CardTitle>
                                <CardDescription className="text-gray-600">
                                    {availableJudges.length} judge{availableJudges.length !== 1 ? 's' : ''} available for assignment
                                </CardDescription>
                            </div>
                        </div>
                    </CardHeader>
                    <CardContent>
                        <div className="space-y-3">
                            {availableJudges.map(judge => {
                                const assignedBoulder = competition.boulders?.find(b => b.judgeId === judge._id);
                                return (
                                    <div key={judge._id} className="flex justify-between items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                                        <div className="flex items-center gap-3">
                                            <div className="flex items-center justify-center size-10 bg-gray-100 rounded-full">
                                                <Users className="size-4 text-gray-600" />
                                            </div>
                                            <div>
                                                <p className="font-semibold text-gray-900">{judge.firstname} {judge.lastname}</p>
                                                <p className="text-sm text-gray-600">{judge.phone}</p>
                                            </div>
                                        </div>
                                        <div className="text-right">
                                            {assignedBoulder ? (
                                                <Badge className="bg-orange-100 text-orange-800 border-orange-200 font-medium">
                                                    Assigned to: {assignedBoulder.name}
                                                </Badge>
                                            ) : (
                                                <Badge className="bg-green-100 text-green-800 border-green-200 font-medium">
                                                    Available
                                                </Badge>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </CardContent>
                </Card>

                {/* Boulder Assignment */}
                <Card className="bg-white border-gray-200 shadow-sm">
                    <CardHeader className="pb-4">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-purple-100 rounded-lg">
                                <Mountain className="size-6 text-purple-600" />
                            </div>
                            <div>
                                <CardTitle className="text-xl text-gray-900">Boulder Assignments</CardTitle>
                                <CardDescription className="text-gray-600">
                                    Assign a judge to each boulder (each judge can only be assigned to one boulder)
                                </CardDescription>
                            </div>
                        </div>
                    </CardHeader>
                    <CardContent className="space-y-6">
                        {competition.boulders?.map(boulder => {
                            const assignedJudge = availableJudges.find(j => j._id === boulder.judgeId);
                            const isAssigned = !!boulder.judgeId;
                            const availableJudgesForThisBoulder = getAvailableJudgesForBoulder(boulder);

                            return (
                                <div
                                    key={boulder._id}
                                    className={`p-6 border-2 rounded-xl transition-all ${isAssigned
                                        ? 'border-green-300 bg-green-50 hover:bg-green-100'
                                        : 'border-red-300 bg-red-50 hover:bg-red-100'
                                        }`}
                                >
                                    <div className="flex items-center justify-between mb-4">
                                        <div className="flex items-center gap-3">
                                            <div className={`p-2 rounded-lg ${isAssigned ? 'bg-green-100' : 'bg-red-100'
                                                }`}>
                                                <Mountain className={`size-5 ${isAssigned ? 'text-green-600' : 'text-red-600'
                                                    }`} />
                                            </div>
                                            <div>
                                                <h3 className="font-bold text-lg text-gray-900">{boulder.name}</h3>
                                                {/* <p className="text-sm text-gray-600">Boulder ID: {boulder._id}</p> */}
                                            </div>
                                        </div>
                                        {isAssigned ? (
                                            <div className="flex items-center gap-2 text-green-600">
                                                <CheckCircle className="size-5" />
                                                <span className="font-medium text-sm">Assigned</span>
                                            </div>
                                        ) : (
                                            <div className="flex items-center gap-2 text-red-600">
                                                <AlertTriangle className="size-5" />
                                                <span className="font-medium text-sm">Unassigned</span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="space-y-3">
                                        <Label htmlFor={`judge-${boulder._id}`} className="text-gray-700 font-medium text-sm">
                                            Assigned Judge
                                        </Label>
                                        <Select
                                            value={boulder.judgeId || 'none'}
                                            onValueChange={(value) => handleAssignJudge(boulder._id, value)}
                                            disabled={loading}
                                        >
                                            <SelectTrigger
                                                id={`judge-${boulder._id}`}
                                                className={`h-11 border-gray-300 focus:border-blue-500 focus:ring-blue-500 ${isAssigned ? 'bg-green-50' : 'bg-red-50'
                                                    }`}
                                            >
                                                <SelectValue placeholder="Select a judge" />
                                            </SelectTrigger>
                                            <SelectContent className="bg-white border-gray-200">
                                                <SelectItem value="none" className="text-gray-600">
                                                    No judge assigned
                                                </SelectItem>
                                                {availableJudgesForThisBoulder.map(judge => (
                                                    <SelectItem
                                                        key={judge._id}
                                                        value={judge._id}
                                                        className="text-gray-700"
                                                    >
                                                        <div className="flex flex-col">
                                                            <span className="font-medium">
                                                                {judge.firstname} {judge.lastname}
                                                            </span>
                                                            {assignedJudgeIds.includes(judge._id) && judge._id !== boulder.judgeId && (
                                                                <span className="text-xs text-orange-600">
                                                                    Currently assigned to another boulder
                                                                </span>
                                                            )}
                                                        </div>
                                                    </SelectItem>
                                                ))}
                                            </SelectContent>
                                        </Select>
                                        {isAssigned && assignedJudge && (
                                            <p className="text-sm text-green-600 font-medium">
                                                ✓ Currently assigned to: {assignedJudge.firstname} {assignedJudge.lastname}
                                            </p>
                                        )}
                                        {availableJudgesForThisBoulder.length === 0 && !isAssigned && (
                                            <p className="text-sm text-red-600 font-medium">
                                                ⚠ No available judges. All judges are already assigned to other boulders.
                                            </p>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </CardContent>
                </Card>

                {/* Navigation */}
                <div className="flex gap-4 pt-6 border-t border-gray-200">
                    <Button
                        variant="outline"
                        onClick={() => navigate('/judge-management', { state: competition })}
                        className="flex-1 border-gray-300 text-gray-700 hover:bg-gray-50 font-medium h-12"
                    >
                        Back to Judge Management
                    </Button>
                    <Button
                        onClick={handleSave}
                        className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium h-12"
                        disabled={loading}
                    >
                        {loading ? (
                            <span className="flex items-center justify-center">
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Saving...
                            </span>
                        ) : (
                            'Save & Continue'
                        )}
                    </Button>
                </div>
            </div>
        </div>
    );
};